export { default } from "bullitttime-embercomponents/components/events-card";
